import { config, errToast, splitFullName } from "../../utils";
import { toast } from "react-toastify";
import buyerSlice, { handleCalculateFinalPrice, handlePrivateAuctionDetails, updateBuyerRegistrationField } from "../slice/buyerSlice";
import { isCancel } from "axios";
import { axiosAuth, axiosUnauth } from "../../utils/axios/axios";
import { handleSiteLoader } from "./authAction";
import { ACCOUNT, DOMAIN } from "../../utils/constants";
import {
    BUYER_REGISTRATION_STEPS,
    BUYER_REGISTRATION_STEPS_BY_INDEX,
    BUYER_REGISTRATION_STEPS_LIVE_BY_INDEX,
    RegistrationFlowType,
} from "../../components/partials/property-details/right-panel/bidder-registration/constant";
import { format, parseISO } from "date-fns";
import { sendNotification } from "../../components/notifications/NotificationService";
import { handleSelection } from "../slice/liveAuctionSlice";

export const buyerAction = buyerSlice.actions;
export const handleDiscoverAuctions = (formData, signal) => {
    return async (dispatch, getState) => {
        const state = getState();
        const isAuthenticated = state.auth.isAuthenticated;
        try {
            const response = await (isAuthenticated ? axiosAuth : axiosUnauth)({
                url: "/api-property/front-property-listing/",
                method: "post",
                data: formData,
                ...config,
                ...(signal ? { signal } : {}),
            });
            return response.data;
        } catch (err) {
            if (!isCancel(err)) errToast(err);
        }
    };
};

export const registerPropertyInterest = (property, remember_me = false) => {
    return async (dispatch, getState) => {
        dispatch(handleSiteLoader(true));
        const state = getState();
        const user = state.auth.user?.user_id || null;
        try {
            const res = await axiosAuth.post(
                `/api-property/register-property-interest/`,
                { property, remember_me, user },
                config
            );
            const { data, status } = res;
            if (status === 200) {
                if (data.error === 0) {
                    toast.success(data.msg);
                    sendNotification();
                    return true;
                } else {
                    errToast(data.msg);
                }
            } else errToast(data.msg);
            return false;
        } catch (err) {
            errToast(err);
        } finally {
            dispatch(handleSiteLoader(false));
        }
    };
};

export const fetchWinningProperty = (page = 1, page_size = 2) => {
    return async (dispatch, getState) => {
        handleSiteLoader(true);
        const state = getState();
        const user = state.auth.user?.user_id || null;
        try {
            const res = await axiosAuth.post(
                `/api-property/buyer-won-listing/`,
                { user_id: user, site_id: DOMAIN, page, page_size },
                config
            );
            const { data, status } = res;
            if (status === 200) {
                if (data.error === 0) {
                    const total = data?.data?.total;
                    const wonData = data?.data?.data;
                    dispatch(
                        buyerAction.setWonAuctionData({ total, data: wonData })
                    );
                    return true;
                } else {
                    errToast(data.msg);
                }
            } else errToast(data.msg);
            return false;
        } catch (err) {
            errToast(err);
        } finally {
            handleSiteLoader(false);
        }
    };
};

export const retractBidBuyer = (property_id) => {
    return async (dispatch, getState) => {
        handleSiteLoader(true);
        const state = getState();
        const user_id = state.auth.user?.user_id || null;
        try {
            const { status, data } = await axiosAuth.post(
                `/api-bid/retract-bid-buyer/`,
                { property_id, user_id, site_id: DOMAIN },
                config
            );
            if (status === 200) {
                if (data.error === 0) {
                    sessionStorage.setItem("isRetractedBid", 1);
                    toast.success(data.msg);
                } else {
                    errToast(data.msg);
                }
            } else errToast(data.msg);
            return { status, data };
        } catch (err) {
            errToast(err);
        } finally {
            handleSiteLoader(false);
        }
    };
};

export const fetchQuantaAPIData = (endPoint) => {
    return async (dispatch, getState) => {
        try {
            const state = getState(),
                propertyData = state?.seller?.property?.propertyData,
                isAuthenticated = state.auth.isAuthenticated;

            const formData = {
                endpoint: endPoint,
                quanta_data: {
                    municipality: propertyData?.municipality,
                    district: propertyData?.district,
                    community: propertyData?.community,
                    project: propertyData?.project_name,
                    propertyLayout: `${propertyData?.beds}`,
                    propertyType:
                        propertyData?.property_type?.toLowerCase() ?? "",
                    // propertyType:
                    //     propertyData?.property_project_data?.property_types?.join(
                    //         " / "
                    //     ),
                },
            };

            const { status, data } = await (
                isAuthenticated ? axiosAuth : axiosUnauth
            )({
                url: `/api-property/get-quanta-data/`,
                method: "post",
                data: formData,
                ...config,
            });
            if (status === 200 || status === 201) {
                return data?.data;
            } else errToast(data.msg);
        } catch (err) {
            // if (!isCancel(err)) errToast(err);
            console.log("Error fetching Quanta API data:", err);
        }
    };
};

export const updateFailedPaymentStatus = (transactionId) => {
    return async (dispatch, getState) => {
        try {
            const state = getState(),
                isAuthenticated = state.auth.isAuthenticated,
                user = state.auth.user?.user_id || null;

            const formData = {
                transactionId,
                user_id: user,
                site_id: DOMAIN,
            };

            const { status, data } = await (
                isAuthenticated ? axiosAuth : axiosUnauth
            )({
                url: `/api-bid/update-failed-payment-status/`,
                method: "post",
                data: formData,
                ...config,
            });
            if (status === 200 || status === 201) {
                return data?.data;
            } else errToast(data.msg);
        } catch (err) {
            console.log("Error fetching Quanta API data:", err);
        }
    };
};

export const sendValuationDocument = (property_id, signal, t) => {
    return async (dispatch, getState) => {
        dispatch(handleSiteLoader(true));
        const {
            auth: { isAuthenticated },
        } = getState();

        try {
            const axiosInstance = isAuthenticated ? axiosAuth : axiosUnauth;

            const response = await axiosInstance.post(
                "/api-property/send-valuation-document/",
                {
                    property_id,
                    domain_id: DOMAIN,
                },
                {
                    ...config,
                    ...(signal && { signal }),
                }
            );
            const data = response?.data;
            if (data?.code === 1 && data?.error === 0) {
                toast.success(
                    t(data.msg || "Valuation Report Sent Successfully.")
                );
            } else {
                toast.error(t(data.msg));
            }
            return data;
        } catch (err) {
            if (isCancel(err)) return;
            errToast(err);
        } finally {
            dispatch(handleSiteLoader(false));
        }
    };
};

export const setPreferredTime = (property, request_date, signal) => {
    return async (dispatch, getState) => {
        dispatch(handleSiteLoader(true));
        const {
            auth: { isAuthenticated },
        } = getState();

        try {
            const axiosInstance = isAuthenticated ? axiosAuth : axiosUnauth;

            const response = await axiosInstance.post(
                "/api-property/add-property-visit-request/",
                {
                    property,
                    request_date: request_date || new Date().toISOString(),
                },
                {
                    ...config,
                    ...(signal ? { signal } : {}),
                }
            );

            const { data } = response;

            if (data?.code === 1 && data?.error === 0) {
                toast.success(data.msg || "Preferred Time Saved Successfully.");
            }

            return data;
        } catch (err) {
            if (isCancel(err)) return;
            errToast(err);
        } finally {
            dispatch(handleSiteLoader(false));
        }
    };
};

let priceAbortController = null;

//Final Price Calculation
export const calFinalPrice = (formData, t) => {
    return async (dispatch, getState) => {
        if (priceAbortController) {
            priceAbortController.abort();
        }
        priceAbortController = new AbortController();

        dispatch(handleCalculateFinalPrice({ dataLoading: true }));
        const isAuthenticated = getState().auth.isAuthenticated;
        const account = getState().profile.account;

        try {
            const res = await (isAuthenticated ? axiosAuth : axiosUnauth).post(
                "/api-property/price-calculation/",
                formData,
                {
                    ...config,
                    signal: priceAbortController.signal,
                }
            );

            // if (res.data.error === 1) {
            //     dispatch(handleCalculateFinalPrice({ error: true }));
            //     if(res.data.msg==="Property settings not found.") toast.error(t("We couldn’t find the property settings."))
            //     return res.data;
            // }
            if (res.data.error === 0) {
                dispatch(
                    handleCalculateFinalPrice({
                        error: false,
                        ...(account === ACCOUNT.Buyer
                            ? res.data.data.buyer_price
                            : res.data.data.seller_price),
                    })
                );
            }

            return res.data;
        } catch (err) {
            if (err.name !== "CanceledError") {
                errToast(err);
                dispatch(handleCalculateFinalPrice({ error: true }));
            }
        } finally {
            dispatch(handleCalculateFinalPrice({ dataLoading: false }));
        }
    };
};

export const handleAuctionBidRegistration = (formData, signal) => {
    return async (dispatch, getState) => {
        const state = getState();
        const isAuthenticated = state.auth.isAuthenticated;
        dispatch(handleSiteLoader(true));
        try {
            const response = await (isAuthenticated ? axiosAuth : axiosUnauth)({
                url:
                    "auction_session" in formData
                        ? "/api-bid/session-bid-registration/"
                        : "/api-bid/bid-registration/",
                method: "post",
                data: formData,
                ...config,
                ...(signal ? { signal } : {}),
            });
            return response?.data;
        } catch (err) {
            errToast(err);
            console.info("Auction Bid Registration Error:", err);
        } finally {
            dispatch(handleSiteLoader(false));
        }
    };
};

export const savePurchaseAgreement = (formData) => {
    return async (dispatch, getState) => {
        try {
            const res = await axiosAuth.post(
                `/api-property/save-purchase-agreement/`,
                formData,
                config
            );
            return res.data;
        } catch (err) {
            errToast(err);
        } finally {
        }
    };
};

export const fetchAuctionBidRegistrationDetail = (payload = {}, signal) => {
    return async (dispatch, getState) => {
        const { property_id, session_id, selfRegistration } = payload;
        const state = getState();
        const user = state.auth.user;
        const isAuthenticated = state.auth.isAuthenticated;
        dispatch(handleSiteLoader(true));
        try {
            const response = await (isAuthenticated ? axiosAuth : axiosUnauth)({
                url:
                    "session_id" in payload
                        ? `api-bid/session-registration-detail/${DOMAIN}/${session_id}/`
                        : `/api-bid/registration-detail/${DOMAIN}/${property_id}/`,
                method: "get",
                ...config,
                ...(signal ? { signal } : {}),
            });

            const { code, error, data } = response?.data || {};

            if (code !== 1 || error !== 0) {
                // "session_id" in payload && dispatch(
                //     updateBuyerRegistrationField({
                //         value: {
                //             showForm: true,
                //             registrationType: RegistrationFlowType.SELF,
                //         }
                //     })
                // );
                console.info("Registration Detail Error:", response?.data);
                return null;
            }

            const {
                id,
                registration_id,
                is_approved,
                term_accepted,
                email,
                first_name: firstName,
                phone_country_code,
                phone_no,
                is_payment_completed,
                registration_type: registrationType,
                country_id: countryId,
                nationality_id: nationalityId,
                city_id: cityId,
                id_type,
                id_number,
                poa_expiry_date,
                step,
                dob,
                documents,
                address_first,
                community,
                community_ar,
                state,
                auction_start,
                lots,
                deposit_amount,
                bid_limit,
            } = data || {};

            if (is_payment_completed && registration_id && is_approved === 2) {
                return response?.data;
            }

            const poaExpiryDate = poa_expiry_date
                ? typeof poa_expiry_date === "string"
                    ? parseISO(poa_expiry_date)
                    : poa_expiry_date
                : null;

            const commonPayload = {
                ...splitFullName(firstName),
                email,
                phone_country_code,
                // phone: `${phone_country_code}${phone_no}`,
                phone: `${phone_no}`,
                ...(lots && {
                    auction_session: session_id,
                }),
            };

            const selfPayload = {
                dob,
                nationality: nationalityId,
                country: countryId,
                city: cityId,
                address_first,
                completed: true,
            };

            const principalPayload = {
                id_type,
                id_number,
                poa_expiry_date: poaExpiryDate
                    ? format(poaExpiryDate, "yyyy-MM-dd")
                    : null,
                completed: true,
            };
            const allowSelf = selfRegistration && registrationType === 2;
            const registrationSection =
                registrationType === 1
                    ? RegistrationFlowType.SELF
                    : RegistrationFlowType.PRINCIPAL;

            const stepSpecificPayload =
                registrationSection === RegistrationFlowType.SELF
                    ? selfPayload
                    : principalPayload;
            session_id && dispatch(
                handleSelection({
                    deposit_amount: Number(deposit_amount) || 0,
                    bidding_limit: Number(bid_limit) || 0
                })
            );

            lots &&
                dispatch(
                    updateBuyerRegistrationField({
                        field: "selectedLots",
                        value: lots,
                    })
                );

            dispatch(
                updateBuyerRegistrationField({
                    value: allowSelf
                        ? {
                              showForm: true,
                              registrationType: RegistrationFlowType.SELF,
                              registration_id: id,
                          }
                        : {
                              state,
                              community,
                              community_ar,
                              auction_start,
                              showForm: true,
                              registrationType: registrationSection,
                              registration_id: id,
                              reservation_agreement_accepted: term_accepted,
                              step:
                                  step != null
                                      ? ((session_id
                                            ? BUYER_REGISTRATION_STEPS_LIVE_BY_INDEX
                                            : BUYER_REGISTRATION_STEPS_BY_INDEX)[
                                            registrationSection
                                        ]?.[step] ?? step)
                                      : BUYER_REGISTRATION_STEPS.DETAILS,
                              ...((registrationSection ===
                                  RegistrationFlowType.SELF &&
                                  step === 4 &&
                                  session_id) ||
                              (registrationSection ===
                                  RegistrationFlowType.PRINCIPAL &&
                                  step === 4 &&
                                  session_id) ||
                              (registrationSection ===
                                  RegistrationFlowType.SELF &&
                                  step === 2) ||
                              (registrationSection ===
                                  RegistrationFlowType.PRINCIPAL &&
                                  step === 3)
                                  ? { isBidderRegistrationModalOpen: true }
                                  : {}),
                          },
                })
            );

            !allowSelf &&
                dispatch(
                    updateBuyerRegistrationField({
                        section: registrationSection,
                        stepKey: "stepOneData",
                        value: {
                            ...commonPayload,
                            ...stepSpecificPayload,
                            isKycAvailable: session_id ? true : false,
                        },
                    })
                );

            if (
                registrationSection === RegistrationFlowType.PRINCIPAL &&
                documents?.[0] &&
                !allowSelf
            ) {
                const { principal_id_document, power_of_attorney_document } =
                    documents[0];
                dispatch(
                    updateBuyerRegistrationField({
                        section: registrationSection,
                        stepKey: "stepTwoData",
                        value: {
                            completed: true,
                            principalIdDoc: principal_id_document ?? null,
                            powerOfAttorneyDoc:
                                power_of_attorney_document ?? null,
                        },
                    })
                );
            }
            return response?.data;
        } catch (err) {
            errToast(err);
            console.info("Fetch Auction Bid Registration Error:", err);
            return null;
        } finally {
            dispatch(handleSiteLoader(false));
        }
    };
};

export const fetchKycDetail = (payload = {}) => {
    return async (dispatch, getState) => {
        const { session_id } = payload;
        const user = getState()?.auth?.user;
        try {
            const response = await axiosAuth.get(
                `/api-bid/user-kyc-details/`,
                config
            );

            const { data } = response?.data || {};
            // if (!Object.keys(data || {}).length) {
            //     session_id && dispatch(
            //         updateBuyerRegistrationField({
            //             value: {
            //                 showForm: true,
            //                 registrationType: RegistrationFlowType.SELF,
            //             }
            //         })
            //     );
            //     return null;
            // }

            // if (Object.keys(data || {}).length && session_id) {
            //     return
            // }

            // session_id && dispatch(
            //     updateBuyerRegistrationField({
            //         value: {
            //             showForm: !Object.keys(data || {}).length ? true : false,
            //             registrationType: RegistrationFlowType.SELF,
            //         }
            //     })
            // );
            // return null;

            const {
                birth_date,
                full_name,
                street_name,
                state_name,
                country,
                issuing_country_code,
                email,
                phone_county_code,
                phone_no,
            } = data || {};

            const selfPayload = {
                dob: birth_date ?? null,
                ...(full_name?.trim() || user?.first_name?.trim()
                    ? splitFullName(full_name || user?.first_name?.trim())
                    : {}),
                address_first: street_name ?? "",
                state_name: state_name ?? "",
                country_name: country || issuing_country_code || "",
                issuing_country_code: issuing_country_code ?? "",
                email: email ?? user?.email ?? "",
                phone_country_code:
                    phone_county_code ?? user?.phone_country_code ?? "",
                phone: phone_no ?? user?.phone_no ?? "",
                // Gate on whether we actually have prefill data, not on
                // live-session context, so non-live registration can also
                // skip the form when KYC data is on file.
                isKycAvailable: Boolean(Object.keys(data || {}).length),
            };

            // session_id && dispatch(
            //     updateBuyerRegistrationField({
            //         value: {
            //             showForm: !Object.keys(data || {}).length ? true : false,
            //             registrationType: RegistrationFlowType.SELF,
            //         }
            //     })
            // );

            dispatch(
                updateBuyerRegistrationField({
                    value: {
                        registrationType: RegistrationFlowType.SELF,
                        // Non-live: always reveal the (self-submitting)
                        // details step immediately — we always have enough
                        // data from the auth profile to submit, KYC or not.
                        // Live: keep requiring real KYC data, unchanged.
                        showForm: session_id
                            ? Boolean(Object.keys(data || {}).length)
                            : true,
                    },
                })
            );

            dispatch(
                updateBuyerRegistrationField({
                    section: RegistrationFlowType.SELF,
                    stepKey: "stepOneData",
                    value: {
                        ...selfPayload,
                    },
                })
            );

            return data;
        } catch (error) {
            console.info(error);
            errToast(error);
            return null;
        }
    };
};

export const fetchRegistrationRejectReason = ({ propertyId } = {}) => {
    return async (dispatch) => {
        if (!propertyId) {
            console.warn(
                "fetchRegistrationRejectReason: propertyId is required"
            );
            return null;
        }

        try {
            const response = await axiosAuth.get(
                `/api-bid/registration-reject-reason/${DOMAIN}/${propertyId}/`,
                config
            );

            const { data } = response?.data || {};
            if (!Object.keys(data || {}).length) return null;

            const { is_approved, seller_comment } = data || {};

            dispatch(
                updateBuyerRegistrationField({
                    value: {
                        is_approved,
                        seller_comment,
                    },
                })
            );
            return data;
        } catch (error) {
            errToast(error);
            return null;
        }
    };
};

export const fetchSavePurchaseAgreement = (propertyId) => {
    return async (dispatch, getState) => {
        try {
            const res = await axiosAuth.get(
                `/api-property/purchase-agreement-details/${propertyId}/`,
                config
            );
            return res.data;
        } catch (err) {
            errToast(err);
        } finally {
        }
    };
};

export const fetchForefitCalulation = (propertyId) => {
    return async (dispatch, getState) => {
        try {
            const res = await axiosAuth.get(
                `/api-bid/forfeit-calculation/${propertyId}/`,
                config
            );
            return res.data;
        } catch (err) {
            errToast(err);
        } finally {
        }
    };
};


export const validateInvitationToken = (token) => {
    return async (dispatch, getState) => {
        dispatch(handleSiteLoader(true));
        try {
            const res = await axiosUnauth.post(
                `/api-property/auction-invitation-token-validate/`,
                {
                    token
                },
                config
            );
            const { data, status } = res;
            if (status === 200 && data?.error === 0) {
                dispatch(handlePrivateAuctionDetails({ ...data?.data, token }))
            }
            return res.data
        } catch (err) {
            errToast(err);
        } finally {
            dispatch(handleSiteLoader(false));
        }
    };
};


export const consumedInvitationToken = (token) => {
    return async (dispatch, getState) => {
        dispatch(handleSiteLoader(true));
        try {
            const res = await axiosAuth.post(
                `/api-property/auction-invitation-token-consume/`,
                {
                    token
                },
                config
            );
            const { data, status } = res;
            console.info({ data, status })
            if (status === 200 && data?.error === 0) {
                // dispatch(handlePrivateAuctionDetails({ reset: true }))
            } else error(data.msg);
            return res
        } catch (err) {
            errToast(err);
        } finally {
            dispatch(handleSiteLoader(false));
        }
    };
};